<template>
  <div>
    <menu-public />
    <v-app>
      <v-main>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>

        <div
          v-if="!userAuth"
          class="w-full bg-gradient-to-r border-t-2 border-gray-400 from-white to-gray-100 py-2 px-2 text-center fixed  sm:hidden bottom-0 z-20"
        >
          <div class="flex flex-row text-center">
            <div class="ml-2 mr-3 flex-1">
              <a
                @click="isManagement()"
                class="shadow-xl  block py-1 pl-1 no-underline border-b-2 border-gray-500"
              >
                <i class="fas fa-home text-blue-600"></i
                ><span class="pb-1 text-xs text-gray-800 block">Manage</span>
              </a>
            </div>

            <div @click="isBuyer()" class="mr-3 flex-1">
              <a
                class="block py-1 pl-1 shadow-xl  no-underline border-b-2 border-gray-500"
              >
                <i class="fas fa-link text-blue-600"></i
                ><span class="pb-1 text-xs text-gray-800 block">Buy</span>
              </a>
            </div>

            <div class="mr-3 flex-1">
              <a
                @click="isSeller()"
                class="block py-1 pl-1 shadow-xl no-underline border-b-2 border-gray-500"
              >
                <i class="fas fa-users text-blue-600"></i
                ><span class="pb-1 text-xs text-gray-800 block">Sell</span>
              </a>
            </div>

            <div class="mr-3 flex-1">
              <v-menu top :offset-y="true">
                <template v-slot:activator="{ on, attrs }">
                  <a
                    v-bind="attrs"
                    v-on="on"
                    class="block py-1 pl-1 shadow-xl  no-underline border-b-2 border-gray-500"
                  >
                    <i class="fas fa-bars text-blue-600"></i
                    ><span class="pb-1 text-xs text-gray-800 block">Menu</span>
                  </a>
                </template>
                <v-card class="mx-auto" elevation="2" width="600">
                  <div
                    class="col-span-full text-center border-b-2 border-gray-400 bg-gray-100 py-2 shadow"
                  >
                    <span class="flex justify-center align-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-6 w-6 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                        />
                      </svg>
                      <router-link
                        style="color: black;"
                        class="ml-2 text-sm"
                        to="/login"
                        >Login</router-link
                      >
                    </span>
                  </div>

                  <div class="grid grid-cols-2 gap-4 p-4">
                    <span class="flex py-1 pl-1">
                      <i class="fas fa-users text-blue-600"></i
                      ><router-link
                        style="color: black;"
                        class="ml-2 text-sm"
                        to="/about"
                        >About Us</router-link
                      >
                    </span>

                    <span class="flex py-1 pl-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 text-blue-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <router-link
                        style="color: black;"
                        class="ml-2 text-sm"
                        to="/clients"
                        >Clients</router-link
                      >
                    </span>

                    <span class="flex py-1 pl-1">
                      <i class="fas fa-users text-blue-600"></i
                      ><router-link
                        style="color: black;"
                        class="ml-2 text-sm"
                        to="/contact"
                        >Contact</router-link
                      >
                    </span>

                    <span class="flex py-1 pl-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 text-blue-600"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M2 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 002 2H4a2 2 0 01-2-2V5zm3 1h6v4H5V6zm6 6H5v2h6v-2z"
                          clip-rule="evenodd"
                        />
                        <path d="M15 7h1a2 2 0 012 2v5.5a1.5 1.5 0 01-3 0V7z" />
                      </svg>

                      <router-link
                        style="color: black;"
                        class="ml-2 text-sm"
                        to="/news"
                        >News/Blogs</router-link
                      >
                    </span>

                    <span class="flex py-1 pl-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 text-blue-600"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"
                        /></svg
                      ><router-link
                        style="color: black;"
                        class="ml-2 text-sm"
                        to="/residents"
                        >Residents</router-link
                      >
                    </span>

                    <span class="flex py-1 pl-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 text-blue-600"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <router-link
                        style="color: black;"
                        class="ml-2 text-sm"
                        to="/reviews"
                        >Reviews</router-link
                      >
                    </span>
                  </div>
                  <div
                    class="col-span-full text-center border-t-2 border-gray-400 bg-gray-100 py-2 shadow"
                  >
                    <router-link
                      style="color: black;"
                      class="ml-2 text-base font-bold "
                      to="/"
                      >Home</router-link
                    >
                  </div>
                </v-card>
              </v-menu>
            </div>
          </div>
        </div>

        <div
          v-else
          class="w-full bg-gradient-to-r border-t-2 border-gray-400 from-white to-gray-100 py-2 px-2 text-center fixed  sm:hidden bottom-0 z-20"
        >
          <div class="flex flex-row text-center">
            <div class="ml-2 mr-3 flex-1">
              <a
                @click="isDashboard()"
                class="shadow-xl block py-1 pl-1 no-underline border-b-2 border-gray-500"
              >
                <i class="fas fa-home text-blue-600"></i
                ><span class="pb-1 text-xs text-gray-800 block">Dashboard</span>
              </a>
            </div>

            <div @click="isManagement()" class="mr-3 flex-1">
              <a
                class="shadow-xl  block py-1 pl-1 no-underline border-b-2 border-gray-500"
              >
                <i class="fas fa-link text-blue-600"></i
                ><span class="pb-1 text-xs text-gray-800 block">Homes</span>
              </a>
            </div>

            <div class="mr-3 flex-1">
              <v-menu top :offset-y="true">
                <template v-slot:activator="{ on, attrs }">
                  <a
                    v-bind="attrs"
                    v-on="on"
                    class="shadow-xl  block py-1 pl-1 no-underline border-b-2 border-gray-500"
                  >
                    <i class="fas fa-bars text-blue-600"></i
                    ><span class="pb-1 text-xs text-gray-800 block">Menu</span>
                  </a>
                </template>

                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <router-link class="nav-item nav-link" to="/about"
                        >About Us</router-link
                      >
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider />
                  <v-list-item>
                    <v-list-item-title>
                      <router-link class="nav-item nav-link" to="/news"
                        >News</router-link
                      >
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider />
                  <v-list-item>
                    <v-list-item-title>
                      <router-link class="nav-item nav-link" to="/residents"
                        >Residents</router-link
                      >
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider />
                  <v-list-item>
                    <v-list-item-title>
                      <router-link class="nav-item nav-link" to="/clients"
                        >360 Clients</router-link
                      >
                    </v-list-item-title>
                  </v-list-item>
                  <v-divider />
                  <v-list-item>
                    <v-list-item-title>
                      <a class="nav-item nav-link" @click="logout">Logout</a>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>

        <div class="w-full bg-gray-100 py-2 absolute sm:hidden top-1 z-20">
          <div v-if="!isAdmin" class="flex justify-between align-center">
            <ul class="flex gap-x-2">
              <li>
                <a href="https://www.facebook.com/homesby360" target="_blank">
                  <img
                    width="20"
                    height="20"
                    alt="facebook"
                    src="https://www.cssscript.com/demo/creating-a-sticky-social-share-bar-with-css3-transitions-and-transforms/img/fb1.png"
                /></a>
              </li>
              <li>
                <a href="https://www.instagram.com/homesby360/" target="_blank">
                  <img
                    width="20"
                    height="20"
                    alt="instagram"
                    src="https://logodownload.org/wp-content/uploads/2017/04/instagram-logo-6.png"
                /></a>
              </li>

              <li>
                <a
                  href="https://www.linkedin.com/in/nicolaburger"
                  target="_blank"
                >
                  <img
                    width="20"
                    height="20"
                    alt="linkedin"
                    src="https://play-lh.googleusercontent.com/kMofEFLjobZy_bCuaiDogzBcUT-dz3BBbOrIEjJ-hqOabjK8ieuevGe6wlTD15QzOqw"
                /></a>
              </li>
            </ul>
            Tel:910-651-0743
            <span class="animate-bounce relative mr-2 flex justify-end">
              <svg
                class="h-5 w-5 font-bold text-blue-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                />
              </svg>
              <b class="mr-2"><a href="tel:19106510743">Call Us!</a></b>
            </span>
          </div>
        </div>
      </v-main>
    </v-app>
  </div>
</template>

<script>
// App.vue - note that what is relevant for Google
// is the 'name' meta tag, the 'description' and the robots meta tag
// using the 'keywords' meta tag won't help, as Google ignores it
import { mapGetters } from "vuex";
export default {
  name: "App",

  metaInfo() {
    return {
      title: "360 Real Estate - full service brokerage firm",
      meta: [
        {
          name: "description",
          content:
            "360 Real Estate is a full service brokerage firm able to buy, sell, rent and manage residential and commercial properties"
        },
        {
          property: "og:title",
          content: "HomesBy360 - full service brokerage firm"
        },
        { property: "og:site_name", content: "360 Real Estate" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://homesby360.s3.amazonaws.com/360.png"
        },
        { name: "robots", content: "index" }
      ]
    };
  },
  computed: {
    isAdmin() {
      if (localStorage.userRole === "admin") {
        return true;
      }
      return false;
    },
    ...mapGetters({
      userAuth: "userAuth"
    })
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },

    goHome() {
      this.$router.push({ name: "Home" });
    },

    isDashboard() {
      this.$router.push({ name: "Dashboard" });
    },

    redirectRental() {
      this.$router.push({ name: "rentals", params: { value: "true" } });
    },

    isManagement() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "ManageRegister",
          params: { state: "Management" }
        });
      }
    },

    isSeller() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "listingRegister",
          params: { state: "Seller" }
        });
      }
    },

    isBuyer() {
      if (this.userAuth) {
        this.$router.push({ name: "listings" });
      } else {
        this.$router.push({
          name: "BuyerRegister",
          params: { state: "Buyer" }
        });
      }
    }
  }
};
</script>
<style>
@import "https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css";
</style>
